import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';

interface LanguageListViewProps extends ComponentViewProps<DataSet<LanguageSummary>> {
	onItemDoubleClicked?: (item: LanguageSummary) => any;
}
export class LanguageListView extends React.Component<LanguageListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: LanguageSummary) => <Link to={`/general/language/${record.languageCode}`}>{text}</Link>,
			},
			{
				key: 'languageCode',
				title: 'Code',
				dataIndex: 'languageCode'
			}
		];
		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						rowKey='languageCode'
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/language/list/language-list.view.tsx